<template>
  <div class="question">
<!--    <div class="m-header">-->
<!--      <div class="header-inner">-->
<!--        <a class="logo">-->
<!--          <img :src="logo" alt="">-->
<!--        </a>-->
<!--      </div>-->
<!--    </div>-->
    <div class="m-banner">
      <img :src="banner" alt="">
    </div>
    <div class="question-main">
      <div class="question-title">
        {{ title }}
      </div>
      <div class="fields-main">
         <div class="style1 statusNoBorder">
           <div class="u-label">{{ questions.question }}</div>
           <div class="m-radio-list ">
             <a-radio-group v-model="value" @change="onChange">
             <a-radio  :style="radioStyle" :value="item.optionId+'|'+item.title" v-for="(item,index) in questions.options" :key="index" class="radio-item">
               {{ item.title }}
             </a-radio>
             </a-radio-group>
           </div>
         </div>
      </div>
    </div>
    <div class="question-main-wap">
         <div class="question-title-wap">
           {{ title }}
         </div>
      <div class="fields-main">
        <div class="style1-wap statusNoBorder">
          <div class="u-label">{{ questions.question }}</div>
          <div class="m-radio-list-wap ">
            <a-radio-group v-model="value" @change="onChange">
              <a-radio  :style="radioStyle" :value="item.optionId+'|'+item.title" v-for="(item,index) in questions.options" :key="index" class="radio-item">
                {{ item.title }}
              </a-radio>
            </a-radio-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {$subscriber, ck, interact} from "fire-wind-water";
import ws from "@/services/webinar";
import webinarService from "@/services/webinar";

export default {
  name: "question",
  data() {
    return {
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      value: '',
      title: '',
      questions: '',
      checkNum: '',
      banner:interact.isMobile === 1?require('@/assets/images/wap-question-banner.png'):require('@/assets/images/pc-question-banner.png'),
      // logo:interact.isMobile === 1?require('@/assets/images/wap-question-logo.png'):require('@/assets/images/pc-question-logo.png'),
      logo:"",
      signUpId:''
    }
  },
  created() {
    window.$sk.loading.hide();
    $subscriber.subscribe("webinarInfo.meeting", data => {
      this.webinarInfo = data;
      this.getUserInfo(data);
      this.getQuestionnaire();
      this.isAllQuestionJoin();
    });
  },
  methods: {
    onChange(e) {
      let param = {
        formData: [],
        enteredId:this.signUpId||'',
        costTime: 37,
        globalUserId: ck.cookie("globalUserId"),
        instanceId: this.webinarInfo.instanceId,
        isAutoAction: 0,
        linkId: null,
        marketingSess: null,
        memberId: '',
        miniToken: '',
        name: '',
        options: [{
          itemId: this.questions.itemId,
          options: [{
            optionId: e.target.value?.split('|')[0]
          }],
        }],
        preview: 0,
        programId: null,
        programType: null,
        programUserId: null,
        questionaryId: this.webinarInfo.questionaryId,
        referenceUrl: "",
        sess: '',
        session: '',
        type: 1,
        unique: '',
        uniqueType: '',
        url: window.location.href,
        wxInfo: {},
        wxQrCode: {},
        _withAsync: 1
      }
      ws.questionaryAction(param).subscribe(res => {
        this.isAllQuestionJoin()
      })
    },
    hasParticipation() {
      ws.hasParticipation({
        globalUserId: ck.cookie("globalUserId"),
        questionaryId: this.webinarInfo.questionaryId
      }).subscribe(data => {
        const hasJoin = data.content.hasJoin == '1'
        console.log('hasJoin', hasJoin);
        this.getQuestionnaire();
        // if(hasJoin){
        //   this.isAllQuestionJoin('default')
        // }else{
        //   this.getQuestionnaire();
        // }
      })
    },
    getQuestionnaire() {
      let param = {
        questionnaireId: this.webinarInfo.questionaryId,
        tenantId: this.webinarInfo.tenantId,
        __module__: 2,
        __objId__: this.webinarInfo.webinarId
      };
      ws.getQuestionnaire(param).subscribe(res => {
        this.title = res.content.title
        this.questions = res.content.items[0];
        console.log('this.questions',this.questions)
      });
    },
    isAllQuestionJoin(type) {
      ws.isAllQuestionJoin({
        "quesitonary": [this.webinarInfo.customFieldObject.questionId, this.webinarInfo.customFieldObject.questionId2],
        globalUserId: ck.cookie("globalUserId"),
      }).subscribe(res => {
        if (res.content.checkAction == '0') {

            if (this.value?.split('|')[1] == '是') {
              window.location.href = this.webinarInfo.customFieldObject.questionPcUrl
            }
            if (this.value?.split('|')[1] == '否') {
              window.location.href = this.webinarInfo.customFieldObject.questionPcUrl1
            }

        }else {
          //  第一个问卷打过
          if(this.webinarInfo.customFieldObject.questionId==res.content.data[0].questionnaireId){
            window.location.href = this.webinarInfo.customFieldObject.questionPcUrl
          }else {
            //  第二个问卷打过
            window.location.href = this.webinarInfo.customFieldObject.questionPcUrl1
          }
        }
      })
    },
    getUserInfo(webinarInfo){
      webinarService
          .getContacts({
            tenantId: webinarInfo.tenantId,
            webinarId: webinarInfo.webinarId,
            sess: "",
            openId:  "",
            globalUserId: ck.cookie("globalUserId")
          })
          .subscribe(data => {
            this.signUpId  =data.content.signUpId
          })
    }

  }
};
</script>

<style scoped lang="scss">
//.question-726{
//  padding-top: 32px;
//}
//@media screen and (max-width: 750px) {
//  .question .m-header{
//    display: none !important;
//  }
//}
</style>